import { getAgencyAbilities, useMe } from './useMe';

export function useAgencyAbilities() {
  const { data: me } = useMe();
  return getAgencyAbilities(me);
}
